// extracted by mini-css-extract-plugin
module.exports = {"sideBar":"Sidebar_sideBar__ii-eq","link":"Sidebar_link__2rNV2"};